import loadRelatedProductCatalog from '../marketing/loadRelatedProductCatalog'

let catalogPromise = null

/** One shared catalog fetch for Блог product tiles / pickers. */
export const loadRelatedProductCatalogCached = () => {
  if (!catalogPromise) {
    catalogPromise = loadRelatedProductCatalog().catch((error) => {
      catalogPromise = null
      throw error
    })
  }
  return catalogPromise
}

export default loadRelatedProductCatalogCached
